import { createReducer, on } from "@ngrx/store";
import { ButtonDesign, IntegrationForm, QRDesign, LigaDesign, SpeechDesign } from "src/app/integration/models/integration.model";
import { clearQr, setFormQR, setStepQr, updateButton, updatePartialButton, updatePartialQr, updatePartialLiga, updatePartialSpeech, updatePartialImageUpload, ImageUploadDesign } from "./integration.actions";

export interface IntegrationQRState {
	form: IntegrationForm;
  step: number;
  buttonDesign: ButtonDesign;
  QRDesign: QRDesign;
  LigaDesign: LigaDesign;
  SpeechDesign: SpeechDesign;
  ImageUpload: ImageUploadDesign;
}

export const initialState: IntegrationQRState = {
	form: {
    name: '',
    url: '',
    plattformSwitch: false,
    projectSwitch: false,
    troderSwitch: false,
    ektSwitch: false,
    urlSwitch: false,
    plattformName: '', 
    plattformValue: '',
    projectName: '',
    troderName: '',
    valid: false
  },
  step: 1,
  buttonDesign: {
    title: '',
    subtitle: '',
    share: '',
    color: '',
    typeIcon: 'icon',
    icon: '',
    showTooltip: false,
    textTooltip: '',
    valid: false,
  },
  QRDesign: {
    color: '',
    title: '',
    description: '',
    valid: false,
  },
  LigaDesign: {
    title: '',
    description: '',
    valid: false,
  },
  SpeechDesign: {
    message: '',
    valid: false,
  },
  ImageUpload: {
    enabled: false,
    file: null,
    fileName: '',
    imageUrl: '',
    valid: true,  // Válido por defecto porque es opcional
  }
}

export const integrationReducer = createReducer(
  initialState,
  on(clearQr, (state) => ({...initialState})),
  on(setFormQR, (state, {data}) => ({...state, form: data})),
  on(setStepQr, (state, {step}) => ({...state, step})),
  // on(updateForm, (state, {key, value}) => ({...state, form: { ...state.form, [key]: value }})),
  on(updateButton, (state, {key, value}) => ({...state, buttonDesign: { ...state.buttonDesign, [key]: value }})),
  on(updatePartialButton, (state, {data}) => ({...state, buttonDesign: { ...state.buttonDesign, ...data }})),
  on(updatePartialQr, (state, {data}) => ({...state, QRDesign: { ...state.QRDesign, ...data }})),
  on(updatePartialLiga, (state, {data}) => ({...state, LigaDesign: { ...state.LigaDesign, ...data }})),
  on(updatePartialSpeech, (state, {data}) => ({...state, SpeechDesign: { ...state.SpeechDesign, ...data }})),
  on(updatePartialImageUpload, (state, {data}) => ({...state, ImageUpload: { ...state.ImageUpload, ...data }})),
);